import { render, staticRenderFns } from "./MassageDesc.vue?vue&type=template&id=0615058d&"
import script from "./MassageDesc.vue?vue&type=script&lang=js&"
export * from "./MassageDesc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports